<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { loadGLTF } from '../../Reusable/loadGLTF'
import { LoadingManager } from '../../Reusable/LoadingManager'
// import { ShaderCube } from '../../Reusable/ShaderCube'
import { MeshMatcapMaterial, DoubleSide, TextureLoader } from 'three'

export default {
  mixins: [O3DG2],
  data () {
    return {
      layouts: {}
    }
  },
  created () {
    let texLoader = new TextureLoader(LoadingManager)
    this.brown = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/brown.png')) })
    this.yellow = new MeshMatcapMaterial({ color: 0xffd743, side: DoubleSide, matcap: texLoader.load(require('./matcap/bright-yellow.png')) })
    this.pink = new MeshMatcapMaterial({ color: 0xffffff, side: DoubleSide, matcap: texLoader.load(require('./matcap/pink.jpg')) })
  },
  methods: {
    setup () {
      let flowerURL = require('file-loader!./glb/flower-simple.glb')

      loadGLTF(flowerURL)
        .then((glb) => {
          console.log(glb)
          glb.scene.traverse((item) => {
            if (item.isMesh) {
              // console.log(item.name)
              if (item.name.indexOf('Plane') !== -1) {
                item.material = this.pink
              }
              if (item.name.indexOf('Sphere') !== -1) {
                item.material = this.yellow
              }
              if (item.name.indexOf('Circle') !== -1) {
                item.material = this.brown
              }
            }
          })
          this.o3d.rotation.z = Math.PI * 0.25
          this.o3d.rotation.y = Math.PI * -0.5
          this.o3d.add(glb.scene)
          this.onLoop(() => {
            glb.scene.rotation.x += 0.01
          })
        })

      // let geo = new BoxBufferGeometry(30, 30, 30, 30, 30, 30)
      // let mat = new MeshBasicMaterial({ wireframe: true, color: 0xff00ff })
      // let mesh = new Mesh(geo, mat)
      // this.onLoop(() => {
      //   mesh.rotation.x += 0.01
      // })

      // this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>